__turbopack_context__.v({
  "message": "mGxLBG_message",
  "slideInAnimation": "mGxLBG_slideInAnimation",
  "spinner": "mGxLBG_spinner",
  "spinnerLargeIcon": "mGxLBG_spinnerLargeIcon",
  "spinnerSmallIcon": "mGxLBG_spinnerSmallIcon",
  "spinnerWrapper": "mGxLBG_spinnerWrapper",
});
